// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem_menuItem__4kiNT","iconWrapper":"MenuItem_iconWrapper__G72aL","content":"MenuItem_content__JFDob","text":"MenuItem_text__187fd","active":"MenuItem_active__u3Unw"};